"use client";

import { useEffect } from "react";
import * as Sentry from "@sentry/nextjs";
import AppError from "~/components/AppError/AppError";
import { usePathname } from "next/navigation";

export default function Error(props: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  const { error, reset } = props;

  const pathname = usePathname();
  const location = pathname.split("/")[1];

  useEffect(() => {
    Sentry.captureException(error);
  }, [error]);

  return (
    <AppError
      error={error}
      reset={reset}
      redirect={{ label: "Home", href: `/${location}/` }}
    />
  );
}
